"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METASITE_APP_DEF_ID = exports.META_SITE_APP_ID = exports.DEFAULT_EXPIRATION_TIME = void 0;
exports.DEFAULT_EXPIRATION_TIME = 210 * 60 * 1000; // 210 minutes = 3.5 hours
exports.META_SITE_APP_ID = -666;
exports.METASITE_APP_DEF_ID = '22bef345-3c5b-4c18-b782-74d4085112ff';
//# sourceMappingURL=constants.js.map